import React, { LegacyRef } from 'react';
import { RowProps } from 'antd/lib/descriptions/Row';

export type AppBodyRowProps = RowProps & {
    accessibilityLabel?: string;
};

export const AppBodyRow = React.forwardRef(
    (
        { accessibilityLabel, ...wrapperDefaultProps }: AppBodyRowProps,
        ref: LegacyRef<HTMLTableRowElement>,
    ) => <tr ref={ref} aria-label={accessibilityLabel} {...wrapperDefaultProps} />,
);
